import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Call } from 'sharedTypes/call';
import { LoggedUpdate } from 'sharedTypes/client';
import { FirebaseService } from 'src/app/services/firebase.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
    selector: 'app-client-call-list',
    standalone: false,
    templateUrl: './client-call-list.component.html',
    styleUrls: ['./client-call-list.component.scss'],
})
export class ClientCallListComponent implements OnInit {
    @Input() clientId: string = '';
    @Input() leadId: string = '';
    calls: Array<Call> = [];
    callSub: Subscription = new Subscription();

    constructor(private firebaseService: FirebaseService, public glo: GlobalService) {}

    ngOnInit(): void {
        if (this.clientId) {
            this.callSub = this.firebaseService.getClientCalls(this.clientId).subscribe((calls) => {
                this.calls = calls;
            });
        }
        if (this.leadId) {
            this.callSub = this.firebaseService.getLeadCalls(this.leadId).subscribe((calls) => {
                this.calls = calls;
            });
        }
    }

    ngOnDestroy(): void {
        this.callSub.unsubscribe();
    }
}
